import { Divider, type SxProps } from "@mui/material";

export const CellDivider = ({ sx }: { sx?: SxProps }) => {
  return (
    <Divider
      orientation="vertical"
      sx={{
        position: "absolute",
        top: 0,
        bottom: 0,
        right: 0,
        left: "auto",
        ...sx,
      }}
    />
  );
};
